import PackageDialog from './PackageDialog';

export default PackageDialog;
